import { useQuery } from '@tanstack/react-query'
import { ApiClient } from '../api'

// Per-event Quick Reference hook (Resources Panel rebuild, spec 23 v2).
// 5 min staleTime — the underlying narrative + activities + roster doesn't
// change second-to-second, and the panel is opened on demand rather than
// polled. Cache key is per-event so opening on event A doesn't refetch B.

export function useQuickReference(eventId: number) {
  return useQuery({
    queryKey: ['quick-reference', eventId],
    queryFn: () => ApiClient.quickReference(eventId),
    enabled: Number.isFinite(eventId) && eventId > 0,
    staleTime: 5 * 60_000
  })
}
